import { Component, OnInit, inject } from '@angular/core';
import { ConfirmDialogService } from '@services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-confirm-dialog-teacher',
  templateUrl: './confirm-dialog-teacher.component.html',
  styleUrls: ['./confirm-dialog-teacher.component.scss'],
  standalone: false,
})
export class ConfirmDialogTeacherComponent implements OnInit {
  private confirmDialogService = inject(ConfirmDialogService);

  data = {
    title: '確認',
    content: 'このまま戻ると、作成中の内容は破棄されます。<br> 破棄しますか？',
    acceptButton: '取り下げる',
    cancelButton: 'キャンセル',
  };
  acceptButtonClass = 'is-danger';

  ngOnInit() {
    this.confirmDialogService.eventShow.subscribe((obj) => {
      Object.assign(this.data, obj || {});
      this.setAcceptButtonClass(obj);
      this.confirmDialogService.isShow = true;
    });
  }

  submitModal(value: boolean) {
    this.confirmDialogService.isShow = false;
    this.confirmDialogService.closeConfirm(value);
  }

  get isShow() {
    return this.confirmDialogService.isShow;
  }

  private setAcceptButtonClass(options: any): void {
    if ('isPrimary' in options && options.isPrimary === true) {
      this.acceptButtonClass = 'is-primary';
    } else {
      this.acceptButtonClass = 'is-danger';
    }
  }
}
